import { jsx } from 'react/jsx-runtime';
import Script from 'next/script';

const MicrosoftClarityScript = ({ tagId, }) => (jsx(Script, { id: "microsoft-clarity", strategy: "afterInteractive", children: `
      (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src='https://www.clarity.ms/tag/'+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, 'clarity', 'script', '${tagId}');
    ` }));

export { MicrosoftClarityScript as M };
//# sourceMappingURL=component-Dw3detUu.js.map
